module.exports = __webpack_public_path__ + "img/img46.01675816.png";